function Footer() {
  const year = new Date().getFullYear();

  return (
    <div className="flex items-center justify-center py-3">
      <p>All Rights Reserved &#169; Caribbean Smart Systems </p>
    </div>
  );
}

export default Footer;
